import UserAccountButton from "components/containers/UserAccountButton/UserAccountButton";
import ContactButton from "components/containers/ContactButton/ContactButton";
import LoginButton from "components/containers/LoginButton";
// główny layout - środkowa belka nagłówka

import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Person } from 'react-bootstrap-icons';
import classnames from 'classnames';
import { useAppNavigate } from 'hooks';
import { useDispatch, useSelector, reduxActions } from 'store';
import { Search, CartsButton } from 'components/containers';
import { Container, Link } from 'components/controls';
import ShoppingListButton from 'components/containers/ShoppingListButton';
import ChatLauncher from 'components/containers/ChatLauncher';
import logo from 'assets/logo.svg';
import styles from 'theme/components/layouts/MainLayout/components/HeaderMain/HeaderMain.module.scss';
const HeaderMain = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    t
  } = useTranslation();
  const navigate = useAppNavigate();
  const {
    profile
  } = useSelector(state => state.auth);
  const [trigerReset, setTriggerReset] = useState(false);
  const renderLogo = () => <button onClick={() => {
    navigate('/');
    setTimeout(() => {
      dispatch(reduxActions.setSearchKeyword(''));
      setTriggerReset(true);
    }, 10);
  }} className={styles.logo}>
      <img src={logo} alt="logo" />
    </button>;
  const renderSearch = () => <Search trigerReset={trigerReset} setTriggerReset={setTriggerReset} />;
  const renderChatLauncher = () => <ChatLauncher />;
  const renderButtons = () => <div className={styles.buttons}>
      <ContactButton />
      {profile?.role == "ROLE_OPEN_PROFILE" ? <LoginButton /> : <>
          <UserAccountButton />
          <ShoppingListButton />
        </>}

      <CartsButton />
    </div>;
  return <div className={classnames(styles.componentWrapper, "StylePath-Components-Layouts-MainLayout-Components-HeaderMain")}>
      <Container>
        <div className={styles.main}>
          {renderLogo()}
          {renderSearch()}
          {renderButtons()}
        </div>
      </Container>
    </div>;
};
export default HeaderMain;